import React, { FunctionComponent } from "react";
import { MENU_ITEMS } from "constants/menu/menu";
import { useAuthUser } from "hooks/useAuthUser";
import { rightUtils } from "utils/business/rightUtils";
import MenuList from "@mui/material/MenuList";
import { MenuItem } from "interfaces/menu/menu";
import { Collapse } from "@mui/material";
import { SideMenuItem } from "components/molecules/menu/SideMenu/SideMenuItem";

interface SideMenuPageItemsProps {
    mobileMenuOpen: boolean;
    reduce: boolean;
    onCloseMobileMenu: () => void;
    selectedItem: MenuItem;
    selectedSubItem: MenuItem;
    onSelectMenuItem: (item:MenuItem) => void;
    subMenuOpen: boolean;
}

export const SideMenuPageItems: FunctionComponent<SideMenuPageItemsProps> = ({
    mobileMenuOpen,
    reduce,
    onCloseMobileMenu,
    selectedItem,
    selectedSubItem,
    onSelectMenuItem,
    subMenuOpen,
}) => {

    const { user, userDetails } = useAuthUser();
    const permissions = userDetails.permissions;

    const menuItemEl = (item: MenuItem) => {
        return <SideMenuItem
            key={item.label}
            icon={<item.Icon fontSize="small" />}
            reduce={reduce}
            item={item}
            selectedItem={selectedItem}
            selectedSubItem={selectedSubItem}
            onSelectMenuItem={onSelectMenuItem}
            mobileMenuOpen={mobileMenuOpen}
            onCloseMobileMenu={onCloseMobileMenu}
            subMenuOpen={subMenuOpen}
        />
    };

    const inCollapse = (item: MenuItem) => {
        return subMenuOpen && selectedItem?.label === item?.label;
    };
    const menuItems = MENU_ITEMS.filter(item => !item.permission || rightUtils.hasPermission(permissions, item.permission));

    return (
        <>
            {!!user &&
                <MenuList sx={{ padding: 0 }}>
                    {menuItems.map((item, i) => {
                        return (
                            <span key={i}>
                                {menuItemEl(item)}
                                {item.subItems &&
                                    <Collapse key={i} in={subMenuOpen}>
                                        {item.subItems.map((sub, index) => {
                                            sub.isSubItem = true;
                                            return (<span key={index}>
                                                {menuItemEl(sub)}
                                            </span>)
                                        })}
                                    </Collapse>
                                }
                            </span>
                        )
                    }
                    )}
                </MenuList>
            }
        </>
    )
}
